// 获取url中的参数名对应的参数值
export const getUrlKey = (name) => {
  return decodeURIComponent(
    // eslint-disable-next-line no-sparse-arrays
    (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

